import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Coupon = ApplicationRecord.extend({
  static: {
    jsonapiType: 'coupons',
  },
  attrs: {
    active: attr(),
    availableGrades: attr(),
    availableSchools: attr(),
    code: attr(),
    couponType: attr(),
    endDate: attr(),
    value: attr(),
    daysPostJob: attr({ persist: false }),
    daysPostJobStart: attr({ persist: false }),
    promoHeadline: attr({ persist: false }),
    promoSubhead: attr({ persist: false }),
    useInOrderFlow: attr({ persist: false }),
    imageUrl: attr(),
  },
});

export default Coupon;
